var swiper = new Swiper(".product-slider", {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        1400: {
            slidesPerView: 3.8,
            spaceBetween: 20
        },
        990: {
            slidesPerView: 3.2,
            spaceBetween: 20
        },
        750: {
            slidesPerView: 2.2,
            spaceBetween: 20
        },
        0: {
            slidesPerView: 1.2,
            spaceBetween: 10
        },
    }
});


